import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as AlertIcon } from '../../assets/icons/alert.svg';
import { setErrorAction } from '../../store/error/actions';
import { Container, Text1, Text2 } from './styles';

const Error: React.FC = () => {
  const email = useSelector(
    (state: ApplicationState) => state.config.emailAssessoria
  );

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setErrorAction(false));
  }, [dispatch]);

  return (
    <Container>
      <AlertIcon style={{ width: 60, height: 60 }} />
      <Text1>Desculpe! Não conseguimos concluir sua solicitação</Text1>
      <Text2>
        Houve um pequeno problema ao efetuar a sua solicitação. Tente novamente
        mais tarde ou entre em contato com a assessoria pelo email{' '}
        <a href={`mailto:${email}`}>{email}</a> ou através de um dos meios listados
        abaixo.
      </Text2>
    </Container>
  );
};

export default Error;
